import React from "react";
import {LuAsterisk, LuInfo, LuX} from "react-icons/lu";
import {Dialog, Heading, Modal} from "react-aria-components";
import Notification from "../../../components/Notification/Notification.js";

export function VisibleSchemasDisabledInfoButton() {
    let [showModal, setShowModal] = React.useState(false);

    function toggleModal() {
        setShowModal(!showModal);
    }

    return <div className="hosting-info-button">
        <LuInfo onClick={toggleModal}/>
        <Modal isOpen={showModal} isDismissable onOpenChange={toggleModal}>
            <Dialog aria-label="Hosting Mode Info" className="hosting-info-modal">
                <Heading className="title">Visible Schemas</Heading>
                <p className="description">
                    This setting allows you to control which schemas are visible in the
                    database. If there are schemas you want nobody to see, you can disable them here.
                </p>
                <Notification>
                    Disabled prior to proxy initialization
                </Notification>
                <div className="close"><LuX onClick={toggleModal}/></div>
            </Dialog>
        </Modal>
    </div>
}